import { useEffect } from 'react';
import { bind } from 'bind-event-listener';

import { expValEquals } from '@confluence/feature-experiments';

// Focus the main content area for live pages Full Page Editor mount. This will occur on:
// 1. Initial page load
// 2. Any page transition that lands on a live page
export const useFullPageAutoFocus = (isLivePage: boolean) => {
	useEffect(() => {
		if (
			isLivePage ||
			expValEquals('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)
		) {
			const mainContent = document.getElementById('AkMainContent');
			// If the main content area is not found, or it already has a tabIndex set,
			// don't mess with tabIndex at all.
			if (!mainContent || mainContent.hasAttribute('tabIndex')) {
				return;
			}
			mainContent.setAttribute('tabIndex', '-1');
			const unbind = bind(mainContent, {
				type: 'blur',
				listener: () => {
					mainContent.removeAttribute('tabIndex');
					unbind();
				},
			});
			mainContent.focus();
			return unbind;
		}
	}, [isLivePage]);
};
